import { BufferGeometry, type Mesh } from "three"
import loadSingleModelAndMerge from "../../../fn/loadSingleModelAndMerge"
import {
  Quaternius_UltimateNaturePack_CommonTree_CommonTree_3_GLTF_Model,
  Quaternius_UltimateNaturePack_CommonTree_CommonTree_4_GLTF_Model,
  Quaternius_UltimateNaturePack_PalmTree_PalmTree_1_GLTF_Model,
  Quaternius_UltimateNaturePack_PalmTree_PalmTree_3_GLTF_Model,
  Quaternius_UltimateNaturePack_PalmTree_PalmTree_4_GLTF_Model
} from "../../../gltf_models.generated"
import creaseMeshGeometryNormals from "../../../fn/creaseMeshGeometryNormals"

// Cache for loaded geometries
let cachedPromise: Promise<BufferGeometry[]> | undefined

function meshTest (mesh: Mesh) {
  creaseMeshGeometryNormals(mesh)
  return true
}

export default function loadAndMergeJungleTreeGeometry(): Promise<BufferGeometry[]> {
  if (!cachedPromise) {
    // console.log('Loading jungle tree models...')
    
    cachedPromise = Promise.all([
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_PalmTree_PalmTree_1_GLTF_Model, 1, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_PalmTree_PalmTree_3_GLTF_Model, 1, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_PalmTree_PalmTree_4_GLTF_Model, 1, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_CommonTree_CommonTree_3_GLTF_Model, 1, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_CommonTree_CommonTree_4_GLTF_Model, 1, meshTest),
    ])
  }

  return cachedPromise
}
